export default __webpack_public_path__ + "static/media/sandboxx-horizontal.c5058d66.svg";